import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { isArray, isEmpty } from 'lodash';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Container, Row, Col, OverlayTrigger, Popover } from 'react-bootstrap';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../Components/Utility/Loader/Loader';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import '../../SpecTemplate/SpecTemplate.css';
import noImage from '../../../../assets/images/no-image.png';
import { shortenandHoverString } from '../../../../Components/helper';
import { usePomGroupContextState } from './PomGroupListContext';
import * as action from '../Store/Pom.action';
import '../Pom.css';
import PomTabs from '../PomTabs';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';

function PomList() {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const expandSearchRefBin = useRef(null);
  const history = useHistory();

  const { pomGroupListState, pomGroupListSetState, pomAddEditAccess, pomDeleteAccess, isallChecked, handleCheckAll, loggedInUserId } =
    usePomGroupContextState();
  const { searchText, hasMore, selectedIds, expandCard } = pomGroupListState;

  const resetSpecState = () => {
    pomGroupListSetState((prev) => ({
      ...prev,
      cardList: [],
      pageIndex: 1,
      hasMore: false,
      searchText: '',
    }));
  };
  useEffect(() => {
    return () => {
      resetSpecState();
      dispatch(action.clearReducer());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const imgSrc = (element) => {
    if (!element?.image || isEmpty(element?.image)) return noImage;
    try {
      return `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${element.image}`;
    } catch (error) {
      console.error('Invalid URL:', error);
      return noImage;
    }
  };
  const handleNextPageInScroll = async () => {
    const nextPageIndex = pomGroupListState.pageIndex + 1;
    pomGroupListSetState((prevState) => ({
      ...prevState,
      pageIndex: nextPageIndex,
      pageLoading: true,
    }));

    const params = {
      pageIndex: nextPageIndex,
      pageSize: pomGroupListState?.pageSize,
      searchText,
      section: 'libraries',
      action: 'read',
      module: 'pomGrading',

      loggedInUserId,
    };

    const result = await dispatch(action.fetchPomGroupsData(params));
    if (result) {
      pomGroupListSetState((prevState) => ({
        ...prevState,
        pageLoading: false,
      }));
    }
  };

  const onCheck = (e, id) => {
    const updatedIds = e.target.checked ? [...selectedIds, id] : selectedIds.filter((arrId) => arrId !== id);

    pomGroupListSetState((prev) => ({
      ...prev,
      selectedIds: updatedIds,
    }));
  };

  const handleTemplateSearch = (value) => {
    pomGroupListSetState((prev) => ({
      ...prev,
      searchText: value,
      searchLoaded: true,
    }));
  };

  const deleteCard = (item) => {
    pomGroupListSetState((prev) => ({
      ...prev,
      showDeletePopup: true,
      delete: { id: item?._id, image: item?.image, fullImage: item?.fullImage },
    }));
  };

  const multiDeleteCard = () => {
    pomGroupListSetState((prev) => ({
      ...prev,
      showMulteDeletePopup: true,
    }));
  };

  const toggleDeleteModal = () => {
    pomGroupListSetState((prev) => ({
      ...prev,
      loading: false,
      showDeletePopup: false,
      showMulteDeletePopup: false,
      selectedIds: [],
      delete: [],
    }));
  };

  const confirmDelete = async () => {
    pomGroupListSetState((prev) => ({
      ...prev,
      loading: true,
      cardList: [],
    }));
    const paramData = { deletedData: [pomGroupListState?.delete], section: 'libraries', module: 'pomGrading', action: 'delete' };
    const res = await dispatch(action.deletePomGroup(paramData, t));
    if (res) {
      const fetchParams = {
        pageIndex: 1,
        pageSize: pomGroupListState?.pageSize,
        searchText,
        section: 'libraries',
        module: 'pomGrading',
        action: 'read',
        loggedInUserId,
      };

      dispatch(action.clearReducer());
      dispatch(action.fetchPomGroupsData(fetchParams));
      toggleDeleteModal();
    }
  };

  const confirmMultiDelete = async () => {
    const filteredId = pomGroupListState?.cardList.filter((item) => pomGroupListState?.selectedIds.includes(item?._id));
    const filteredData = filteredId.map((item) => {
      return {
        image: item.image,
        fullImage: item.fullImage,
        id: item._id,
      };
    });

    pomGroupListSetState((prev) => ({
      ...prev,
      loading: true,
      cardList: [],
    }));

    const paramData = { deletedData: filteredData, section: 'libraries', module: 'pomGrading', action: 'delete' };
    const res = await dispatch(action.deletePomGroup(paramData, t));
    if (res) {
      const fetchParams = {
        pageIndex: 1,
        pageSize: pomGroupListState?.pageSize,
        searchText,
        section: 'libraries',
        module: 'spec',
        action: 'read',
        loggedInUserId,
      };

      dispatch(action.clearReducer());
      dispatch(action.fetchPomGroupsData(fetchParams));
      toggleDeleteModal();
    }
  };

  const expandCollapse = (ind) => {
    pomGroupListSetState((prevData) => ({
      ...prevData,
      expandCard: expandCard !== ind ? ind : '',
    }));
  };

  const showCreatedandModified = (item) => {
    return (
      <li>
        <button aria-label="info" type="button" className="btn p-0 d-inline-flex">
          <OverlayTrigger
            placement="bottom"
            trigger="hover"
            rootClose
            overlay={
              <Popover className="custom-popover modified-popover">
                <Popover.Content>
                  <div>
                    <p className="text-left m-0">
                      <strong> {t('COLOR_WAY_CARD.CREATED_BY_DATE_TIME')} </strong> {item.createdBy}{' '}
                      {item.createdAt && moment(item.createdAt).format('DD-MMM-YYYY, HH:mm')}
                    </p>
                    {item?.modifiedBy && (
                      <p className="text-left m-0">
                        <strong> {t('COLOR_WAY_CARD.MODIFIED_BY_DATE_TIME')} </strong> {item.modifiedBy}{' '}
                        {item.lastModifiedAt && moment(item.lastModifiedAt).format('DD-MMM-YYYY, HH:mm')}
                      </p>
                    )}
                  </div>
                </Popover.Content>
              </Popover>
            }
          >
            <i className="icon-Information f-24" />
          </OverlayTrigger>
        </button>
      </li>
    );
  };

  const renderCardList = () => {
    return pomGroupListState?.cardList.map((item, index) => (
      <div key={item?._id} className="common-listing-card card mt-5 mb-16">
        <div className="card-header">
          <ul className={!pomAddEditAccess && !pomDeleteAccess ? 'card-header-icon card-icon-access m-0' : 'card-header-icon m-0'}>
            {(pomDeleteAccess || pomAddEditAccess) && (
              <li>
                <div className="common-checkbox">
                  <input
                    onChange={(e) => {
                      onCheck(e, item?._id);
                    }}
                    name={`check_${index}`}
                    id={`check_${index}`}
                    type="checkbox"
                    checked={selectedIds?.includes(item?._id)}
                  />
                  <label htmlFor={`check_${index}`} className="chklabel" />
                </div>
              </li>
            )}
            {pomAddEditAccess && (
              <li>
                <CustomTooltip placement="top" tooltipText={t('POMS.GRADING_GROUP_LISTING.POM_GROUP.POM_LIST.EDIT')}>
                  <button
                    aria-label="Edit"
                    onClick={() => history.push(`/libraries/pom-group/edit/${item?._id}`)}
                    className="btn p-0 d-inline-flex pt-0"
                    type="button"
                  >
                    <i className="icon-Edit-1" />
                  </button>
                </CustomTooltip>
              </li>
            )}
            {pomDeleteAccess && (
              <li>
                <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.DELETE')}>
                  <button
                    id={`delete_${item?._id}`}
                    aria-label={t('POMS.GRADING_GROUP_LISTING.POM_GROUP.POM_LIST.DELETE')}
                    type="button"
                    className="btn p-0 d-inline-flex m-0"
                    onClick={() => deleteCard(item)}
                  >
                    <i className="icon-Delete" />
                  </button>
                </CustomTooltip>
              </li>
            )}
            {showCreatedandModified(item)}
          </ul>
          <div className="image-detail">
            <div
              className="card-image-preview"
              style={{
                backgroundImage: `url(${imgSrc(item)})`,
              }}
            />
            <span
              className="big-image"
              style={{
                backgroundImage: `url(${imgSrc(item)})`,
              }}
            />
          </div>
        </div>
        <div className="card-body" onClick={() => expandCollapse(index)}>
          <h4 className="title text-decoration-none">{shortenandHoverString(item?.groupName, 20)}</h4>

          <ul className="card-ul">
            <li className="text-truncate">
              <strong>{t('SPEC_TEMP_LIBRARY.CATEGORY1')}:</strong>&nbsp;{shortenandHoverString(item?.catOne?.join(', '), 40)}
            </li>
            <div className={expandCard === index ? 'd-block' : 'd-none'}>
              <li>
                <strong>{t('SPEC_TEMP_LIBRARY.CATEGORY2')}: </strong>
                {shortenandHoverString(item?.catTwo?.join(', '), 40)}
              </li>
              <li>
                <strong>{t('SPEC_TEMP_LIBRARY.CATEGORY3')}: </strong>
                {shortenandHoverString(item?.catThree?.join(', '), 40)}
              </li>
              <li>
                <strong>{t('SPEC_TEMP_LIBRARY.CATEGORY4')}: </strong>
                {shortenandHoverString(item?.catFour?.join(', '), 40)}
              </li>
            </div>
          </ul>
        </div>
      </div>
    ));
  };

  const handleIconBinClick = () => {
    // Add a class to the input on icon click
    expandSearchRefBin.current.classList.toggle('active-input');
  };
  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="pom-title"> {t('POM_GROUP.POM_GROUP')}</h4>
        </div>
        <div className="action-icons-container">
          <div ref={expandSearchRefBin} className="common-expand-search">
            <button type="button" onClick={handleIconBinClick} className="btn btn-toggle">
              <span className="sr-only ">{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.SEARCH USER_INSTRUCTION')}</span>
              <span className="icon-Magnifying-Glass-Solid" />
            </button>
            <input
              type="text"
              className="form-control"
              onChange={(e) => handleTemplateSearch(e.target.value)}
              value={pomGroupListState?.searchText}
              autoComplete="off"
              placeholder={t('POM_GROUP.SEARCH_POM_GROUPS')}
            />
          </div>
          <div className="floting-actions">
            {pomAddEditAccess && (
              <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.ADD')}>
                <button aria-label="save" className="btn d-inline-flex pt-0" onClick={() => history.push('/libraries/pom-group/add')} type="button">
                  <i className="icon-Add" />
                </button>
              </CustomTooltip>
            )}
            {pomDeleteAccess && (
              <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.DELETE')}>
                <button
                  disabled={pomGroupListState?.cardList?.length === 0 || !pomGroupListState?.selectedIds?.length}
                  aria-label="delete"
                  onClick={multiDeleteCard}
                  className="btn d-inline-flex pt-0"
                  type="button"
                >
                  <i className="icon-Delete" />
                </button>
              </CustomTooltip>
            )}
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center">
        <PomTabs />
        {(pomDeleteAccess || pomAddEditAccess) && pomGroupListState?.cardList?.length > 0 && (
          <div className="common-checkbox bold ml-auto mr-24">
            <input type="checkbox" id="addToDesignDetail" name="addToDesignDetail" onChange={handleCheckAll} checked={isallChecked} />
            <label htmlFor="addToDesignDetail" className="chklabel align-items-center">
              <p className="pl-2 mb-0 text-bold f-16">{t('POMS.GRADING_GROUP_LISTING.POM_GROUP.POM_LIST.ALL')}</p>
            </label>
          </div>
        )}
      </div>

      <Container className="pom-group-listing" fluid>
        {pomGroupListState?.loading ? (
          <Loader />
        ) : (
          <>
            {!isArray(pomGroupListState?.cardList) ||
              (pomGroupListState?.cardList.length === 0 && (
                <Row>
                  <Col md="12">
                    <p className="mt-4 justify-content-center align-item-center d-flex">{t('POM_GROUP.NO_ENTRY_FOUND')}</p>
                  </Col>
                </Row>
              ))}

            <InfiniteScroll
              dataLength={pomGroupListState?.cardList?.length}
              loader={pomGroupListState?.pageLoading && <Loader />}
              hasMore={hasMore}
              next={handleNextPageInScroll}
              className="pom-group-listing-scroll"
            >
              <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3, 1440: 4 }}>
                <Masonry className="custom-masonry grid-container" gutter="30px">
                  {renderCardList()}
                </Masonry>
              </ResponsiveMasonry>
            </InfiniteScroll>
          </>
        )}
      </Container>
      {pomGroupListState?.showDeletePopup && (
        <ConfirmationPopup
          onOpen={pomGroupListState?.showDeletePopup}
          onConfirm={confirmDelete}
          title={t('POM_GROUP.DELETE_TITLE')}
          message={t('POM_GROUP.DELETE_POM_GROUP_MESSAGE')}
          toggle={toggleDeleteModal}
          loading={false}
        />
      )}

      {pomGroupListState?.showMulteDeletePopup && (
        <ConfirmationPopup
          onOpen={pomGroupListState?.showMulteDeletePopup}
          onConfirm={confirmMultiDelete}
          title={t('POM_GROUP.DELETE_TITLE')}
          message={t('POM_GROUP.MULTI_DELETE_MESSAGE')}
          toggle={toggleDeleteModal}
          loading={false}
        />
      )}
    </>
  );
}

export default PomList;
